import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import { ConnectedRouter } from "connected-react-router";
import { IntlProvider } from "react-intl-redux";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/moment";
import store, { history } from "../state";
import Home from "./home";
import "moment/locale/es";
import "bootstrap/dist/css/bootstrap.css";
import "../assets/css/fonts.scss";
import "../assets/css/icons-cepsa.css";
import "../assets/css/style.scss";
import Messages from "./messages/index";
import { initialize } from "../utils/google-analytics-handler";

moment.locale("es");

const cadetBlue = "#22959e";
const cadetBlueDark = "#16767D";
const theme = createMuiTheme({
  fontFamily: "flamabasic",
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: cadetBlue
      }
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: cadetBlue
      },
      current: {
        color: cadetBlueDark
      }
    },
    MuiPickersModal: {
      dialogAction: {
        color: cadetBlue
      }
    }
  }
});

export default () => {
  useEffect(() => {
    initialize();
  }, []);
  return (
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale="es">
        <Provider store={store}>
          <IntlProvider>
            <ConnectedRouter history={history}>
              <Home />
              <Messages />
              <ToastContainer />
            </ConnectedRouter>
          </IntlProvider>
        </Provider>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};
